<template xmlns:v="http://www.w3.org/1999/xhtml">
  <div :title="title" class="rack-on-plan" @dblclick.prevent="dblclick"  @mousedown.prevent="mousedown" :style="style" @contextmenu.prevent="contextmenu" >
    <div class="fulfillment" :style="fulfillmentStyle"></div>
    <div class="title">{{title}}</div>
  </div>
</template>
<!--{{width}}x{{depth}}-->

<script type="text/javascript">
export default {
  name: 'rack-on-plan',
  props: {
    id: String,
    title: String,
    index: Number,
    width: Number,
    height: Number,
    depth: Number,
    isExt: Boolean,
    sort: Number,
    angle: {
      type: Number,
      default: 0,
      required: false,
    },
    fulfillment: {
      type: Number,
      default: 0,
      required: false,
    },
    top: {
      type: Number,
      default: 0,
      required: false,
    },
    left: {
      type: Number,
      default: 0,
      required: false,
    },
    selected: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    style() {
      return {
        width: `${this.width / 10}px`,
        height: `${this.depth / 10}px`,
        top: `${this.top}px`,
        left: `${this.left}px`,
        lineHeight: `${this.depth / 10}px`,
        transform: `rotateZ(${this.angle}deg)`,
// eslint-disable-next-line no-nested-ternary
        borderColor: this.isExt ? 'red' : this.selected ? 'green' : '',
        background: this.selected ? 'rgba(0, 255, 0, 0.2)' : '',
      };
    },
    fulfillmentStyle() {
      return {
        width: `${this.fulfillment}%`,
      };
    },
  },
  methods: {
    contextmenu(e) {
      this.$emit('contextmenu', {
        id: this.id,
        event: e,
        offsetX: e.clientX - this.left,
        offsetY: e.clientY - this.top,
        x: this.left,
        y: this.top,
        angle: this.angle ? this.angle : 0,
        title: this.title,
        isExt: this.isExt,
        sort: this.sort,
      });
    },
    dblclick(e) {
      this.$emit('dblclick', {
        id: this.id,
        event: e,
      });
    },
    mousedown(e) {
      if (!e.metaKey) {
        this.$emit('mousedown', {
          id: this.id,
          title: this.title,
          type: 3,
          event: e,
          offsetX: e.clientX - this.left,
          offsetY: e.clientY - this.top,
          x: this.left,
          y: this.top,
          width: this.width,
          height: this.height,
          depth: this.depth,
        });
      }
    },
  },
  data() {
    return {
    };
  },
};
</script>


<style lang="less" scoped="true">
    .title {
        z-index: 10;
        position: absolute;
    }

    .fulfillment {
        position: absolute;
        height: 100%;
        background: lightblue;
        opacity: 0.5;
        z-index: 2;
    }

    .rack-on-plan {
        border: 1px solid #88929D;
        border-width: 1px 2px;
        box-sizing: border-box;
        position: absolute;
        text-align: center;
        font-size: 12px;
        overflow: hidden;
    }
</style>


// WEBPACK FOOTER //
// RackOnPlan.vue?5f1cf720